import { useEffect, useState } from 'preact/hooks';
import { apiClient } from '../adapters/apiClient.js';
import { ScaleCanvas } from '../components/ScaleCanvas.jsx';

export function PublicSite() {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const next = await apiClient.publicState();
      setState(next);
      setError('');
      window.SoliwodaAgentPublic = Object.freeze({
        getTree: () => structuredClone(next.tree),
        getVersion: () => next.version,
        snapshotTarget: () => window.location.href,
      });
    } catch (loadError) {
      setError(loadError.message);
    }
  };

  useEffect(() => {
    load();
    const events = new EventSource('/api/events');
    events.addEventListener('site.changed', load);
    return () => events.close();
  }, []);

  if (error) return <main class="public-status error" data-testid="public-error">{error}</main>;
  if (!state) return <main class="public-status" data-testid="public-loading">Loading portfolio...</main>;

  return (
    <main class="public-page" data-testid="public-resume" aria-label="Monika Soliwoda resume">
      <ScaleCanvas tree={state.tree} />
    </main>
  );
}
